import { documentHasElements } from "modules/dom";

documentHasElements(".js-global-career-opportunity", () => {

    const careerOpportunity = {
        init: function () {
            careerOpportunity.addSmoothScroll();
        },
        addSmoothScroll: () => {
            const html = document.querySelector("html");
            
            if (html) {
                html.classList.add("html-scroll__smooth");
            }
        },
    };

    careerOpportunity.init();

});